._loader_1kslv_1 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: blueviolet;
  width: 1000px;
  height: 1000px; }
